"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Crown = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.4178 5.41398L10.4679 6.73015L8.76527 3.83378C9.11625 3.59082 9.34615 3.18534 9.34615 2.72616C9.34615 1.9827 8.74346 1.38 8 1.38C7.25654 1.38 6.65385 1.9827 6.65385 2.72616C6.65385 3.18534 6.88375 3.59082 7.23473 3.83378L5.53205 6.73015L3.58225 5.41398C3.65306 5.25027 3.69231 5.06972 3.69231 4.88001C3.69231 4.13654 3.08961 3.53385 2.34615 3.53385C1.60269 3.53385 1 4.13654 1 4.88001C1 5.62347 1.60269 6.22616 2.34615 6.22616C2.3737 6.22616 2.40106 6.22533 2.4282 6.2237L3.15385 9.99539H12.8462L13.5718 6.2237C13.5989 6.22533 13.6263 6.22616 13.6538 6.22616C14.3973 6.22616 15 5.62347 15 4.88001C15 4.13654 14.3973 3.53385 13.6538 3.53385C12.9104 3.53385 12.3077 4.13654 12.3077 4.88001C12.3077 5.06972 12.3469 5.25027 12.4178 5.41398ZM3.5663 11H12.4337C12.7465 11 13 11.214 13 11.5047V12.4953C13 12.774 12.7528 13 12.4337 13H3.5663C3.25354 13 3 12.786 3 12.4953V11.5047C3 11.226 3.24719 11 3.5663 11Z",
    clipRule: "evenodd"
  })));
};